import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/InventoryCustomFields'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class InventoryCustomFieldsStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "InventoryCustomFieldsStore",
			variables: true,
		})
	}
}

export async function load_InventoryCustomFields(params) {
  await initClient()

	const store = new InventoryCustomFieldsStore()

	await store.fetch(params)

	return {
		InventoryCustomFields: store,
	}
}
